'use client'

import { HeaderContainer } from '@/src/components/common/header/HeaderRouter'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { Box } from '@mui/material'

export interface HotelDesktopPageShellProps {
    /** Unique per page for the content ErrorBoundary; the header gets `${identifier}-header`. */
    identifier: string
    domainCountry?: string
    children: React.ReactNode
}

// Shared desktop hotels chrome: the fixed shared header plus the content area offset below
// it, each in its own ErrorBoundary. Extracted from the per-page containers (home, results,
// details, itinerary, guest-details, payment, confirmation) which all repeated this frame.
const HotelDesktopPageShell: React.FC<HotelDesktopPageShellProps> = ({ identifier, domainCountry, children }) => (
    <Box>
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100 }}>
            <ErrorBoundaryWrapper identifier={`${identifier}-header`}>
                <HeaderContainer domainCountry={domainCountry} activeVertical="hotels" />
            </ErrorBoundaryWrapper>
        </Box>

        <Box sx={{ mt: '54px' }}>
            <ErrorBoundaryWrapper identifier={identifier}>{children}</ErrorBoundaryWrapper>
        </Box>
    </Box>
)

export { HotelDesktopPageShell }
export default HotelDesktopPageShell
